'use client'
import React from 'react'
import styles from './styles.module.scss'

const PageContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <div className={styles.container}>{children}</div>
}

export default PageContainer
